<h2 mat-dialog-title i18n="@@notificationSettingsTitle">
  Benachrichtigungseinstellungen
</h2>
<mat-dialog-content class="settings-dialog-content">
  <p class="description" i18n="@@notificationSettingsChooseChannels">
    Wählen Sie die Kanäle für Ihre Benachrichtigungen.
  </p>
  <form
    class="settings-form"
    [formGroup]="form"
    (ngSubmit)="save()"
    id="notification-settings-form"
    [attr.aria-busy]="saving()"
  >
    @for (channel of channels; track channel.key) {
      <div class="setting-item">
        <div class="setting-header">
          <span [id]="channel.key + '-label'">{{ channel.title }}</span>
          <mat-slide-toggle
            [formControlName]="channel.key"
            [aria-labelledby]="channel.key + '-label'"
            [aria-describedby]="channel.key + '-description'"
          />
        </div>
        <p class="setting-helper-text" [id]="channel.key + '-description'">
          {{ channel.description }}
        </p>
      </div>
    }
  </form>
  <p class="description scope" role="status">
    @if (allDisabled()) {
      <span i18n="@@notificationSettingsAllDisabled"
        >Alle automatischen Mitarbeiterbenachrichtigungen sind
        deaktiviert.</span
      >
    } @else {
      <span i18n="@@notificationSettingsScope"
        >Diese Einstellungen gelten für automatische Benachrichtigungen an
        Sie.</span
      >
    }
  </p>
  <p class="description exceptions" i18n="@@notificationSettingsExceptions">
    Kundennachrichten, selbst angeforderte Sendungen und Kontonachrichten
    bleiben unverändert.
  </p>
  @if (failed()) {
    <div class="save-error" role="alert">
      <mat-icon aria-hidden="true">error_outline</mat-icon
      ><span i18n="@@notificationSettingsSaveError"
        >Einstellungen konnten nicht gespeichert werden. Ihre Änderungen bleiben
        erhalten. Bitte versuchen Sie es erneut.</span
      >
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-dialog-close
    color="warn"
    type="button"
    [disabled]="saving()"
  >
    <mat-icon>close</mat-icon>
    <span i18n="@@notificationSettingsCancel">Abbrechen</span>
  </button>
  <button
    mat-raised-button
    color="primary"
    type="submit"
    form="notification-settings-form"
    [disabled]="saving() || !changed()"
  >
    @if (saving()) {
      <mat-spinner diameter="18" aria-hidden="true" />
    } @else {
      <mat-icon>save</mat-icon>
    }
    @if (saving()) {
      <span i18n="@@notificationSettingsSaving">Wird gespeichert …</span>
    } @else {
      <span i18n="@@notificationSettingsSave">Speichern</span>
    }
  </button>
</mat-dialog-actions>
